module.exports = __webpack_public_path__ + "static/media/cc_icon-paypal.dd405bd7.svg";